import { REST_METHOD, REST_URL } from 'constants/index';
import { requestProvisioning } from './api';
import { SoftwareSubscription } from 'models';
import { AxiosResponse } from 'axios';

const getListSoftwareSubscription = async (email: string): Promise<SoftwareSubscription[]> => {
  try {
    const requestParams = {
      url: `${REST_URL.USERS}/${email}`,
      method: REST_METHOD.GET,
    };

    const response = await requestProvisioning(requestParams);
    return response.data;
  } catch (error) {
    throw error;
  }
};

const checkValidateSoftware = async ({
  email,
  sku,
  userSysId,
  requestType = "app_request",
}: {
  email: string;
  sku: string;
  userSysId: string;
  requestType?: string;
}) => {
  try {
    const requestParams = {
      url: `${REST_URL.USERS}/${email}${REST_URL.SOFTWARES}/${sku}${REST_URL.ENTILE}`,
      method: `${REST_METHOD.POST}`,
      data: {
        request_type: requestType,
        user_sys_id: userSysId,
      },
    };
    const response = await requestProvisioning(requestParams);
    return response;
  } catch (error) {
    throw error;
  }
};

const submitSoftwareOrder = async (data: any) => {
  try {
    const requestParams = {
      url: `${REST_URL.SOFTWARE_SUBCRIPTION}`,
      method: `${REST_METHOD.POST}`,
      data: data,
    };
    const response = await requestProvisioning(requestParams);
    return response;
  } catch (error) {
    throw error;
  }
};

const getEligibleVirtualDesktop = async (email: string) => {
  try{
    const requestParams = {
      url: `${REST_URL.USERS}/${email}${REST_URL.ELIGIBLE_VIRTUAL_DESKTOPS}`,
      method: REST_METHOD.GET,
    }
    const response = await requestProvisioning(requestParams);
    if (!response.data) {
      return;
    }
    return response.data;
  }
  catch(error) {
    throw error
  }
};

const getEligibleVirtualApp = async (email: string) => {
  try{
    const requestParams = {
      url: `${REST_URL.USERS}/${email}${REST_URL.ELIGIBLE_VIRTUAL_APPS}`,
      method: REST_METHOD.GET,
    }
    const response = await requestProvisioning(requestParams);
    if (!response.data) {
      return;
    }
    return response.data;
  }
  catch(error) {
    throw error
  }
};

const checkEligibleForRequest = async ({
  userEmail,
  requestType,
  requestorSysId,
  groupName,
  appSku,
}: {
  userEmail: string;
  requestType: string;
  requestorSysId: string;
  groupName?: string;
  appSku?: string;
}): Promise<AxiosResponse<{
    success: boolean;
    exceptions: {
      user_in_group: boolean;
      active_ritm: boolean;
    };
  }, any>>  => {
  const requestParams = {
    url: `${REST_URL.USERS}/${userEmail}${REST_URL.ELIGIBLE_FOR_REQUEST}`,
    method: REST_METHOD.POST,
    data: {
      request_type: requestType,
      requestor_sys_id: requestorSysId,
      group_name: groupName,
      app_sku: appSku,
    },
  };
  const response = await requestProvisioning(requestParams);
  return response;
};

const ProvisioningServices = {
  getListSoftwareSubscription,
  checkValidateSoftware,
  submitSoftwareOrder,
  getEligibleVirtualDesktop,
  getEligibleVirtualApp,
  checkEligibleForRequest,
};

export default ProvisioningServices;
